/**
 * Local development only: sign in without typing the password (Javier, 2026-09-24).
 *
 * The backend route exists only with NODE_ENV=development, DEV_AUTO_LOGIN=true and a request
 * from the same machine (see hvp-backend `dev-login.ts`). Here it is tried only when Vite runs
 * in dev mode, the local `.env.development.local` says VITE_DEV_AUTO_LOGIN=true, and there is no
 * session yet. A production build never tries it: `import.meta.env.DEV` is false there.
 */
export function shouldTryDevAutoLogin(env: { DEV?: boolean; VITE_DEV_AUTO_LOGIN?: string }, token: string | null): boolean {
  return env.DEV === true && env.VITE_DEV_AUTO_LOGIN === 'true' && !token;
}
